<template>
    <a class="button button--wide" @click="openPage(link)" :class="{'button--primary': isPrimary}"><slot></slot></a>
</template>

<script>
    export default {
        name: "MenuButton",
        props: {
            isPrimary: {
                type: Boolean,
                default: false
            },
            link: String
        },
        methods: {
            openPage(screen){
                console.log(screen);
                this.$store.state.screen = screen;
            }
        }
    }
</script>

<style scoped>

</style>